"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRedstonePayload = exports.requestDataPackages = exports.getDataServiceIdForSigner = exports.getOracleRegistryState = exports.DEFAULT_CACHE_SERVICE_URLS = void 0;
const axios_1 = __importDefault(require("axios"));
const initial_state_json_1 = __importDefault(require("redstone-oracles-smartweave-contracts/src/contracts/redstone-oracle-registry/initial-state.json"));
const redstone_protocol_1 = require("redstone-protocol");
exports.DEFAULT_CACHE_SERVICE_URLS = [
    "https://oracle-gateway-1.a.redstone.finance",
    "https://oracle-gateway-2.a.redstone.finance",
];
const ALL_FEEDS_KEY = "___ALL_FEEDS___";
const getOracleRegistryState = async () => {
    return initial_state_json_1.default;
};
exports.getOracleRegistryState = getOracleRegistryState;
const getDataServiceIdForSigner = (oracleState, signerAddress) => {
    for (const nodeDetails of Object.values(oracleState.nodes)) {
        if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) {
            return nodeDetails.dataServiceId;
        }
    }
    throw new Error(`Data service not found for ${signerAddress}`);
};
exports.getDataServiceIdForSigner = getDataServiceIdForSigner;
const parseDataPackagesResponse = (dpResponse, reqParams) => {
    var _a;
    const parsedResponse = {};
    const requestedDataFeedIds = (_a = reqParams.dataFeeds) !== null && _a !== void 0 ? _a : [ALL_FEEDS_KEY];
    for (const dataFeedId of requestedDataFeedIds) {
        const dataFeedPackages = dpResponse[dataFeedId];
        if (!dataFeedPackages) {
            throw new Error(`Requested data feed id is not included in response: ${dataFeedId}`);
        }
        if (dataFeedPackages.length < reqParams.uniqueSignersCount) {
            throw new Error(`Too few unique signers for the data feed: ${dataFeedId}. ` +
                `Expected: ${reqParams.uniqueSignersCount}. ` +
                `Received: ${dataFeedPackages.length}`);
        }
        parsedResponse[dataFeedId] = dataFeedPackages
            .sort((a, b) => b.timestampMilliseconds - a.timestampMilliseconds) // we prefer newer data packages in the first order
            .slice(0, reqParams.uniqueSignersCount)
            .map((dataPackage) => redstone_protocol_1.SignedDataPackage.fromObj(dataPackage));
    }
    return parsedResponse;
};
const errToString = (e) => {
    if (e instanceof AggregateError) {
        const stringifiedErrors = e.errors.reduce((prev, oneOfErrors, curIndex) => (prev += `${curIndex}: ${oneOfErrors.message}, `), "");
        return `${e.message}: ${stringifiedErrors}`;
    }
    else {
        return e.message;
    }
};
const requestDataPackages = async (reqParams, urls = exports.DEFAULT_CACHE_SERVICE_URLS) => {
    const promises = prepareDataPackagePromises(reqParams, urls);
    try {
        return await Promise.any(promises);
    }
    catch (e) {
        const errMessage = `Request failed ${JSON.stringify({
            reqParams,
            urls,
        })}, Original error: ${errToString(e)}`;
        throw new Error(errMessage);
    }
};
exports.requestDataPackages = requestDataPackages;
const prepareDataPackagePromises = (reqParams, urls) => {
    return urls.map((url) => axios_1.default
        .get(`${url}/data-packages/latest/${reqParams.dataServiceId}`)
        .then((response) => parseDataPackagesResponse(response.data, reqParams)));
};
const requestRedstonePayload = async (reqParams, urls = exports.DEFAULT_CACHE_SERVICE_URLS, unsignedMetadataMsg) => {
    const signedDataPackagesResponse = await (0, exports.requestDataPackages)(reqParams, urls);
    const signedDataPackages = Object.values(signedDataPackagesResponse).flat();
    return redstone_protocol_1.RedstonePayload.prepare(signedDataPackages, unsignedMetadataMsg || "");
};
exports.requestRedstonePayload = requestRedstonePayload;
exports.default = {
    getOracleRegistryState: exports.getOracleRegistryState,
    requestDataPackages: exports.requestDataPackages,
    getDataServiceIdForSigner: exports.getDataServiceIdForSigner,
    requestRedstonePayload: exports.requestRedstonePayload,
};
//# sourceMappingURL=index.js.map